export default "__VITE_ASSET__Dqdx4q1D__"